import preact from 'preact';
import { AttributesStore } from '../store/AttributesStore';

const { Component, h } = preact;

export default class Frame extends Component {

  componentDidMount() {
    AttributesStore.subscribe(this.onStoreChange.bind(this));

    this.setState({ isIos: AttributesStore.get('isIos') });
  }

  render(props, state) {
    const iosDisplay = (!state.isOpened && state.isIos) ? 'none' : '';

    return <div style={{ display: iosDisplay }}
                class={"frame " + (state.isOpened ? "visible " : "")}>

      <iframe src={props.location}
              allowtransparency="true"
              frameborder="0"
              scrolling="none"
              class="frame__content">
      </iframe>

    </div>;
  }

  onStoreChange(state) {
    let items = state.items || [];

    items = items.filter(ele => ele.isVisible);

    this.setState({ isOpened: items.length && state.isFrameOpened });
  }
}
